import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChangelogService, ChangelogEntry } from '../../services/changelog.service';

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.sass'],
})
export class ChangelogComponent implements OnInit {
  entries: ChangelogEntry[] = [];

  constructor(
    private changelog: ChangelogService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.changelog.init();
    this.changelog.entries$.subscribe(list => { this.entries = list; });
    // Wejście w zakładkę = zmiany przeczytane -> kropka gaśnie.
    this.changelog.markSeen();
  }

  /** Tytuł/treść w języku panelu; fallback: polski (język źródłowy wpisów). */
  private pick(map: { [lang: string]: string } | string | undefined): string {
    if (map == null) { return ''; }
    if (typeof map === 'string') { return map; } // stare, jednojęzyczne wpisy
    const lang = this.translate.currentLang || this.translate.defaultLang || 'pl';
    return map[lang] ?? map['pl'] ?? Object.values(map)[0] ?? '';
  }

  entryTitle(e: ChangelogEntry): string { return this.pick(e.title); }
  entryText(e: ChangelogEntry): string { return this.pick(e.text); }

  /** Kody tagów (new|fix|improve) -> klucz i18n etykiety. */
  tagLabelKey(tag?: string): string {
    switch (tag) {
      case 'new': return 'CHANGELOG.TAG_NEW';
      case 'fix': return 'CHANGELOG.TAG_FIX';
      case 'improve': return 'CHANGELOG.TAG_IMPROVE';
      default: return 'CHANGELOG.TAG_OTHER';
    }
  }

  tagClass(tag?: string): string {
    switch (tag) {
      case 'new': return 'tag-new';
      case 'fix': return 'tag-fix';
      case 'improve': return 'tag-improve';
      default: return 'tag-default';
    }
  }
}
